import axios from "axios";
import { useEffect, useState } from "react";
import { baseUrl } from "./constants";

const useGetAppliedCampaigns = (
  influencerId,
  campaignType,
  campaignStatus,
  approvalStatus
) => {
  const [allAppliedCampaigns, setAllAppliedCampaigns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("token");
  const getData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${baseUrl}/applied/${influencerId}?campaignType=${campaignType}&campaignStatus=${campaignStatus}&approvalStatus=${approvalStatus}`,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      setAllAppliedCampaigns(res?.data);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (influencerId) {
      getData();
    }
  }, [influencerId, campaignType, campaignStatus, approvalStatus]);
  return [isLoading, allAppliedCampaigns];
};

export default useGetAppliedCampaigns;
